// This file is part of MinIO Console Server
// Copyright (c) 2022 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackMessage } from "../../../systemSlice";
import { api } from "api";
import { errorToHandler } from "api/errors";

export const getUsageAsync = createAsyncThunk(
  "dashboard/getUsageAsync",
  async (_, { getState, rejectWithValue, dispatch }) => {
    return api.admin
      .adminInfo()
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        dispatch(setErrorSnackMessage(errorToHandler(err.error)));
        return rejectWithValue(err);
      });
  }
);
